module.exports = __webpack_public_path__ + "img/img_clients3.acf81715.jpg";